import { Box, Button, Flex, Spacer } from "@chakra-ui/react";
import { useCallback, useContext, useState } from "react";
import { FormattedMessage } from "react-intl";

import { ExcelImport, downloadScenarioMetadata } from "@nens/ldo/api-v1";
import { LdoAuthContext } from "@nens/ldo/auth-v1";

import { ExcelImportScenarios } from "./excel-import-scenarios";

interface ExcelImportRowProps {
  excelImport: ExcelImport;
  open: boolean;
  toggleOpen: () => void;
}

export function ExcelImportRow({ excelImport, open, toggleOpen }: ExcelImportRowProps) {
  const { apiFetchFunctionBareResponse } = useContext(LdoAuthContext);
  const numScenarios = excelImport.scenario_ids.length;

  const [exportBusy, setExportBusy] = useState(false);

  const exportAllowed = !exportBusy && numScenarios > 0 && excelImport.status === "finished";

  const clickExport = useCallback(async () => {
    if (exportAllowed) {
      setExportBusy(true);
      await downloadScenarioMetadata(apiFetchFunctionBareResponse, {
        scenarioIds: excelImport.scenario_ids,
      });
      setExportBusy(false);
    }
  }, [exportAllowed, excelImport, apiFetchFunctionBareResponse]);

  const errors = (excelImport?.errors ?? []).map((error) => error.msg);

  return (
    <>
      <Flex
        borderTop="1px solid #ddd"
        p="4"
        key={excelImport.id}
        justifyContent="flex-start"
        cursor={numScenarios > 0 ? "pointer" : undefined}
        _hover={numScenarios > 0 ? { bgColor: "#FCF5F450" } : undefined}
        onClick={numScenarios > 0 ? toggleOpen : undefined}
      >
        <Box w="160px">
          {new Date(excelImport.created_at).toLocaleDateString()}{" "}
          {new Date(excelImport.created_at).toLocaleTimeString()}
        </Box>
        <Box w="70px">{excelImport.status}</Box>
        <Box w="250px">{errors.length === 0 ? "-" : errors}</Box>
        <Box w="70px">
          {excelImport.mode === "create" ? (
            <FormattedMessage id="import.mode.create" defaultMessage="New" />
          ) : (
            <FormattedMessage id="import.mode.update" defaultMessage="Update" />
          )}
        </Box>
        <Box w="70px">{numScenarios}</Box>
        <Box w="290px">{excelImport.created_by.name}</Box>
        <Spacer />
        <Box>
          <Button isDisabled={!exportAllowed} onClick={clickExport}>
            Download scenario metadata
          </Button>
        </Box>
      </Flex>
      {open ? <ExcelImportScenarios excelImportId={excelImport.id} /> : null}
    </>
  );
}
